// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3WMcY","image":"Header_image__3darO","name":"Header_name__3JNtv","info":"Header_info__pazgt","infoRow":"Header_infoRow__2POxg"};